// src/Profil/PodatkiDolznika/PodatkiDolznika.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api";
import "./PodatkiDolznika.css";

const MOZNOSTI_PREDMETA = [
    "Premičnine",
    "Plača",
    "TRR",
    "Vozilo",
    "Drugo",
];

const MOZNOSTI_SREDSTVA = [
    "Rubež premičnin",
    "Rubež plače",
    "Rubež TRR",
    "Drugo",
];

const ustvariPrazniPrejsnjiRubez = (privzetaStevilkaZadeve = "") => ({
    stevilkaRubeza: "",
    izvrsitelj: "",
    glavnicaZarubljena: "",
    predmetRubeza: "",
    sredstvoRubeza: "",
    stevilkaZadeve: privzetaStevilkaZadeve,
});

const jeVeljavenEmail = (v) => {
    const s = (v || "").trim();
    if (!s) return true;

    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(s);
};

const parseMoney = (v) => {
    if (v == null) return null;

    let s = String(v).trim();
    if (!s) return null;

    s = s.replace(/[^\d.,-]/g, "");

    const jeNegativno = s.startsWith("-");
    s = s.replace(/-/g, "");

    const imaVejico = s.includes(",");
    const imaPiko = s.includes(".");
    const steviloPik = (s.match(/\./g) || []).length;

    if (imaVejico && imaPiko) {
        s = s.replace(/\./g, "").replace(",", ".");
    } else if (imaVejico) {
        s = s.replace(",", ".");
    } else if (imaPiko) {
        const zadnjaPika = s.lastIndexOf(".");
        const decimalk = s.length - zadnjaPika - 1;

        if (steviloPik > 1 || decimalk === 3) {
            s = s.replace(/\./g, "");
        }
    }

    if (jeNegativno) s = "-" + s;

    const n = Number(s);
    return Number.isFinite(n) ? n : null;
};

const vDecimalAliNull = (v) => {
    const n = parseMoney(v);
    return n == null ? null : n;
};

const formatMoneySl = (v) => {
    const n = typeof v === "number" ? v : parseMoney(v);

    if (n == null) return "";

    return n.toLocaleString("sl-SI", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const ocistiDenarniVnos = (v) => {
    return String(v || "")
        .replace(/[^\d.,]/g, "")
        .slice(0, 20);
};

export default function PodatkiDolznika() {
    const navigate = useNavigate();

    const [davcnaAliMaticna, setDavcnaAliMaticna] = useState("");
    const [nalaganje, setNalaganje] = useState(false);
    const [napaka, setNapaka] = useState("");
    const [ajpesDolznik, setAjpesDolznik] = useState(null);

    const [nalaganjeIzBaze, setNalaganjeIzBaze] = useState(false);
    const [urejanjeObstojecega, setUrejanjeObstojecega] = useState(false);
    const [stranId, setStranId] = useState(null);

    const [opravilnaStevilkaSodisca, setOpravilnaStevilkaSodisca] = useState("");
    const [stevilkaSpisaIzvrsitelja, setStevilkaSpisaIzvrsitelja] = useState("");

    const [fizicnaOseba, setFizicnaOseba] = useState("");
    const [dolznikoviTrrji, setDolznikoviTrrji] = useState([{ trr: "" }]);
    const [telefonDolznika, setTelefonDolznika] = useState("");
    const [gsmDolznika, setGsmDolznika] = useState("");
    const [ePostaDolznika, setEPostaDolznika] = useState("");
    const [emailNapaka, setEmailNapaka] = useState("");
    const [dolznikoveBanke, setDolznikoveBanke] = useState([
        { banka: "", poljubnaBanka: "" },
    ]);

    const [znesekDolga, setZnesekDolga] = useState("");
    const [imeIzvrsitelja, setImeIzvrsitelja] = useState("");

    const [shranjevanje, setShranjevanje] = useState(false);
    const [sporociloShranjevanja, setSporociloShranjevanja] = useState("");

    const [manjkajocePolje, setManjkajocePolje] = useState("");
    const [manjkajoceSporocilo, setManjkajoceSporocilo] = useState("");

    const [stroski, setStroski] = useState("");
    const [glavnica, setGlavnica] = useState("");
    const [obrestiOd, setObrestiOd] = useState("");
    const [obrestiDo, setObrestiDo] = useState("");
    const [skupajDolgNaDan, setSkupajDolgNaDan] = useState("");

    const [prejsnjiRubezi, setPrejsnjiRubezi] = useState(() => {
        return [ustvariPrazniPrejsnjiRubez("")];
    });

    const normalizirajStevilke = (v) =>
        String(v || "").replace(/\D/g, "").slice(0, 10);

    const oznaciManjkajocePolje = (fieldId, message) => {
        setManjkajocePolje(fieldId);
        setManjkajoceSporocilo(message);
        setSporociloShranjevanja(message);

        requestAnimationFrame(() => {
            const el = document.getElementById(fieldId);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                setTimeout(() => {
                    el.focus?.();
                }, 250);
            }
        });
    };

    const jeManjkajocePolje = (id) => manjkajocePolje === id;

    const obravnavaSpremembeOpravilneStevilke = (e) => {
        setOpravilnaStevilkaSodisca(e.target.value);
    };

    const formatirajTelefonVnos = (value) => {
        let v = String(value || "");
        const imelZakljucekSPresledkom = /\s$/.test(v);

        v = v.replace(/[^\d+ ]/g, "");

        const imaZacetniPlus = v.trimStart().startsWith("+");

        v = v.replace(/\+/g, "");
        v = v.replace(/\s+/g, " ");
        v = v.replace(/^\s+/, "");

        if (imaZacetniPlus) {
            v = "+" + v;
        }

        if (imelZakljucekSPresledkom && !v.endsWith(" ")) {
            v += " ";
        }

        return v;
    };

    useEffect(() => {
        let aktivno = true;

        (async () => {
            try {
                const res = await apiFetch("/api/auth/me");
                if (!res.ok) return;

                const data = await res.json();
                if (!aktivno) return;

                const polnoIme =
                    (data.fullName && data.fullName.trim()) ||
                    [data.firstName, data.lastName].filter(Boolean).join(" ").trim() ||
                    data.email ||
                    "";

                setImeIzvrsitelja(polnoIme);

                setPrejsnjiRubezi((prej) =>
                    prej.map((vrstica) =>
                        vrstica.izvrsitelj ? vrstica : { ...vrstica, izvrsitelj: polnoIme }
                    )
                );
            } catch {
                // ignoriraj
            }
        })();

        return () => {
            aktivno = false;
        };
    }, []);

    const obravnavaSpremembeIskanja = (e) => {
        setNapaka("");
        setAjpesDolznik(null);
        setDavcnaAliMaticna(normalizirajStevilke(e.target.value));
        setUrejanjeObstojecega(false);
        setStranId(null);
    };

    const obravnavaEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            pridobiDolznika();
        }
    };

    const naloziDolznikaIzBazePoStevilki = async (stevke) => {
        setNalaganjeIzBaze(true);
        setSporociloShranjevanja("");
        setNapaka("");

        try {
            const params = new URLSearchParams();
            params.set("davcnaAliMaticna", stevke);

            const res = await apiFetch(`/api/stran/dolznik?${params.toString()}`, {
                method: "GET",
            });

            if (res.status === 404) {
                setUrejanjeObstojecega(false);
                return false;
            }

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || json?.title || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "Napaka pri pridobivanju podatkov iz baze.");
            }

            const data = await res.json();
            const pd = data.podatkiStrani || {};

            setStranId(data.id || null);
            setStevilkaSpisaIzvrsitelja(data.stevilkaSpisaIzvrsitelja || "");
            setOpravilnaStevilkaSodisca(data.opravilnaStevilkaSodisca || "");

            setDavcnaAliMaticna(pd.davcnaAliMaticna || "");
            setAjpesDolznik(pd.ajpesDolznik || null);
            setFizicnaOseba(pd.fizicnaOseba || "");

            if (Array.isArray(pd.dolznikoviTrrji) && pd.dolznikoviTrrji.length > 0) {
                setDolznikoviTrrji(
                    pd.dolznikoviTrrji.map((t) => ({
                        trr: t.trr || t.Trr || "",
                    }))
                );
            } else {
                setDolznikoviTrrji([{ trr: "" }]);
            }

            setTelefonDolznika(pd.telefonDolznika || "");
            setGsmDolznika(pd.gsmDolznika || "");
            setEPostaDolznika(pd.ePostaDolznika || "");

            if (Array.isArray(pd.dolznikoveBanke) && pd.dolznikoveBanke.length > 0) {
                setDolznikoveBanke(
                    pd.dolznikoveBanke.map((b) => ({
                        banka: b.banka || b.Banka || "",
                        poljubnaBanka: b.poljubnaBanka || b.PoljubnaBanka || "",
                    }))
                );
            } else {
                setDolznikoveBanke([{ banka: "", poljubnaBanka: "" }]);
            }

            setZnesekDolga(pd.znesekDolga != null ? formatMoneySl(pd.znesekDolga) : "");
            setGlavnica(pd.glavnica != null ? formatMoneySl(pd.glavnica) : "");
            setStroski(pd.stroski != null ? formatMoneySl(pd.stroski) : "");
            setSkupajDolgNaDan(
                pd.skupajDolgNaDan != null ? formatMoneySl(pd.skupajDolgNaDan) : ""
            );

            setObrestiOd(pd.obrestiOd || "");
            setObrestiDo(pd.obrestiDo || "");

            if (Array.isArray(pd.prejsnjiRubezi) && pd.prejsnjiRubezi.length > 0) {
                setPrejsnjiRubezi(
                    pd.prejsnjiRubezi.map((vrstica) => ({
                        stevilkaRubeza:
                            vrstica.stevilkaRubeza || vrstica.StevilkaRubeza || "",
                        izvrsitelj:
                            vrstica.izvrsitelj ||
                            vrstica.Izvrsitelj ||
                            imeIzvrsitelja ||
                            "",
                        stevilkaZadeve:
                            vrstica.stevilkaZadeve ||
                            vrstica.StevilkaZadeve ||
                            data.opravilnaStevilkaSodisca ||
                            opravilnaStevilkaSodisca ||
                            "",
                        glavnicaZarubljena:
                            vrstica.glavnicaZarubljena != null
                                ? formatMoneySl(vrstica.glavnicaZarubljena)
                                : vrstica.GlavnicaZarubljena != null
                                    ? formatMoneySl(vrstica.GlavnicaZarubljena)
                                    : "",
                        predmetRubeza:
                            vrstica.predmetRubeza || vrstica.PredmetRubeza || "",
                        sredstvoRubeza:
                            vrstica.sredstvoRubeza || vrstica.SredstvoRubeza || "",
                    }))
                );
            } else {
                setPrejsnjiRubezi([
                    {
                        ...ustvariPrazniPrejsnjiRubez(
                            data.opravilnaStevilkaSodisca || opravilnaStevilkaSodisca
                        ),
                        izvrsitelj: imeIzvrsitelja || "",
                    },
                ]);
            }

            setUrejanjeObstojecega(true);
            setSporociloShranjevanja(
                "Shranjeni podatki dolžnika so naloženi iz baze. Uredite jih in shranite."
            );

            return true;
        } catch (e) {
            setSporociloShranjevanja(
                e?.message || "Napaka pri nalaganju podatkov iz baze."
            );
            setUrejanjeObstojecega(false);
            return false;
        } finally {
            setNalaganjeIzBaze(false);
        }
    };

    const pridobiIzAjpes = async () => {
        setNapaka("");
        setAjpesDolznik(null);
        setManjkajocePolje("");
        setManjkajoceSporocilo("");

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!stevke) {
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno ali matično številko."
            );
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno (8) ali matično (10) številk."
            );
            return;
        }

        setDavcnaAliMaticna(stevke);
        setNalaganje(true);

        try {
            const res = await apiFetch(`/api/ajpes/prs/${stevke}`, {
                method: "GET",
            });

            if (!res.ok) {
                let msg = "";

                try {
                    const json = await res.json();
                    msg = json?.message || "";
                } catch {
                    msg = await res.text().catch(() => "");
                }

                throw new Error(msg || "AJPES poizvedba ni uspela.");
            }

            const data = await res.json();
            setAjpesDolznik(data);
            setUrejanjeObstojecega(false);
            setStranId(null);
        } catch (e) {
            setNapaka(e?.message || "Napaka pri AJPES poizvedbi.");
        } finally {
            setNalaganje(false);
        }
    };

    const pridobiDolznika = async () => {
        if (nalaganje || nalaganjeIzBaze) return;

        setSporociloShranjevanja("");
        setNapaka("");
        setUrejanjeObstojecega(false);
        setStranId(null);
        setManjkajocePolje("");
        setManjkajoceSporocilo("");

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!stevke) {
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno ali matično številko."
            );
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno (8) ali matično (10) številk."
            );
            return;
        }

        setDavcnaAliMaticna(stevke);

        const nalozenoIzBaze = await naloziDolznikaIzBazePoStevilki(stevke);

        if (nalozenoIzBaze) {
            return;
        }

        await pridobiIzAjpes();
    };

    const imeDolznika =
        ajpesDolznik?.naziv ??
        ajpesDolznik?.Naziv ??
        ajpesDolznik?.name ??
        ajpesDolznik?.Name ??
        "";

    const naslovDolznika =
        ajpesDolznik?.naslov ??
        ajpesDolznik?.Naslov ??
        ajpesDolznik?.address ??
        ajpesDolznik?.Address ??
        "";

    const postaDolznika =
        ajpesDolznik?.posta ??
        ajpesDolznik?.Posta ??
        ajpesDolznik?.post ??
        ajpesDolznik?.Post ??
        "";

    const drzavaDolznika =
        ajpesDolznik?.drzava ??
        ajpesDolznik?.Drzava ??
        ajpesDolznik?.country ??
        ajpesDolznik?.Country ??
        "";

    const davcnaStevilkaDolznika =
        ajpesDolznik?.davcnaStevilka ??
        ajpesDolznik?.DavcnaStevilka ??
        ajpesDolznik?.taxNo ??
        ajpesDolznik?.TaxNo ??
        "";

    const obravnavaSpremembePrejsnjegaRubeza = (index, polje, vrednost) => {
        setPrejsnjiRubezi((prej) => {
            const naslednje = [...prej];
            naslednje[index] = { ...naslednje[index], [polje]: vrednost };
            return naslednje;
        });
    };

    const dodajPrejsnjiRubez = () => {
        setPrejsnjiRubezi((prej) => [
            ...prej,
            {
                ...ustvariPrazniPrejsnjiRubez(opravilnaStevilkaSodisca),
                izvrsitelj: imeIzvrsitelja || "",
            },
        ]);
    };

    const odstraniPrejsnjiRubez = (index) => {
        setPrejsnjiRubezi((prej) => prej.filter((_, i) => i !== index));
    };

    const shraniStran = async () => {
        if (shranjevanje) return;

        setShranjevanje(true);
        setSporociloShranjevanja("");
        setEmailNapaka("");

        const stevke = normalizirajStevilke(davcnaAliMaticna);

        if (!stevke) {
            setShranjevanje(false);
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno ali matično številko."
            );
            return;
        }

        if (!(stevke.length === 8 || stevke.length === 10)) {
            setShranjevanje(false);
            oznaciManjkajocePolje(
                "iskanjeDolznika",
                "Vpiši davčno (8) ali matično (10) številk."
            );
            return;
        }

        if (!stevilkaSpisaIzvrsitelja.trim()) {
            setShranjevanje(false);
            oznaciManjkajocePolje(
                "stevilkaSpisaIzvrsitelja",
                "Vnesite št. spisa izvršitelja."
            );
            return;
        }

        if (!opravilnaStevilkaSodisca.trim()) {
            setShranjevanje(false);
            oznaciManjkajocePolje(
                "opravilnaStevilkaSodisca",
                "Vnesite opr. št. sodišča."
            );
            return;
        }

        if (!jeVeljavenEmail(ePostaDolznika)) {
            setShranjevanje(false);
            setEmailNapaka(
                "Vnesite veljaven e-poštni naslov ali pustite polje prazno."
            );
            oznaciManjkajocePolje(
                "ePostaDolznika",
                "Vnesite veljaven e-poštni naslov ali pustite polje prazno."
            );
            return;
        }

        const normaliziranEmail = ePostaDolznika.trim() || null;

        try {
            const payload = {
                id: urejanjeObstojecega ? stranId : null,
                stevilkaSpisaIzvrsitelja: stevilkaSpisaIzvrsitelja.trim(),
                opravilnaStevilkaSodisca: opravilnaStevilkaSodisca.trim(),
                podatkiStrani: {
                    davcnaAliMaticna: stevke,
                    ajpesDolznik,
                    fizicnaOseba,
                    dolznikoviTrrji,
                    telefonDolznika: telefonDolznika.replace(/\s/g, ""),
                    gsmDolznika: gsmDolznika.replace(/\s/g, ""),
                    ePostaDolznika: normaliziranEmail,
                    dolznikoveBanke,
                    znesekDolga: vDecimalAliNull(znesekDolga),
                    glavnica: vDecimalAliNull(glavnica),
                    obrestiOd,
                    obrestiDo,
                    stroski: vDecimalAliNull(stroski),
                    skupajDolgNaDan: vDecimalAliNull(skupajDolgNaDan),
                    prejsnjiRubezi: prejsnjiRubezi.map((vrstica) => ({
                        ...vrstica,
                        glavnicaZarubljena: vDecimalAliNull(
                            vrstica.glavnicaZarubljena
                        ),
                    })),
                },
            };

            const res = await apiFetch("/api/stran/dolznik", {
                method: "POST",
                body: payload,
            });

            if (!res.ok) {
                try {
                    const body = await res.json();
                    const emailErr = body?.errors?.["PodatkiStrani.EPostaDolznika"]?.[0];

                    if (emailErr) {
                        setEmailNapaka(emailErr);
                        setSporociloShranjevanja("Popravite označena polja.");
                        setShranjevanje(false);
                        return;
                    }

                    const errors = body?.errors || {};
                    const keys = Object.keys(errors);

                    if (keys.length > 0) {
                        const firstKey = keys[0];
                        const firstError = errors[firstKey]?.[0];

                        setSporociloShranjevanja(
                            firstError ||
                            body?.message ||
                            body?.title ||
                            "Napaka pri shranjevanju podatkov o dolžniku."
                        );
                    } else {
                        setSporociloShranjevanja(
                            body?.message ||
                            body?.title ||
                            "Napaka pri shranjevanju podatkov o dolžniku."
                        );
                    }
                } catch {
                    const text = await res.text().catch(() => "");
                    setSporociloShranjevanja(
                        text || "Napaka pri shranjevanju podatkov o dolžniku."
                    );
                }

                setShranjevanje(false);
                return;
            }

            const saved = await res.json().catch(() => ({}));

            setDavcnaAliMaticna(stevke);
            setStranId(saved?.id || stranId);
            setSporociloShranjevanja("Uspešno shranjeno.");
            setUrejanjeObstojecega(true);

            if (typeof window !== "undefined") {
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            }
        } catch (e) {
            setSporociloShranjevanja(e?.message || "Napaka pri shranjevanju.");
        } finally {
            setShranjevanje(false);
        }
    };

    return (
        <div className="pod-glayout">
            <main className="pod-page">
                <section className="pod-content">
                    <div className="pod-card">
                        <div className="pod-header">
                            <div className="pod-header-brand">
                                <div className="pod-header-meta">
                                    <h1 className="pod-header-title">Podatki o dolžniku</h1>
                                    <p className="pod-header-subtitle">
                                        Pridobitev in dopolnitev podatkov o dolžniku in terjatvi.
                                    </p>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="btn-nazaj"
                                onClick={() => navigate("/profil", { replace: true })}
                                aria-label="Nazaj na profil"
                                title="Nazaj"
                            >
                                <span className="btn-nazaj__icon" aria-hidden="true">
                                    ←
                                </span>
                            </button>
                        </div>

                        <section className="pod-section pod-topRowSection">
                            <div className="pod-topRow">
                                <label className="pod-field">
                                    <span className="pod-label globalniizv-label-icon-wrap">
                                        Izvršitelj
                                    </span>
                                    <input
                                        className="pod-input pod-topInput"
                                        id="imeIzvrsitelja"
                                        name="imeIzvrsitelja"
                                        value={imeIzvrsitelja}
                                        readOnly
                                    />
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">Št. spisa izvršitelja</span>
                                    <input
                                        className={`pod-input pod-topInput ${jeManjkajocePolje("stevilkaSpisaIzvrsitelja")
                                                ? "pod-input--error"
                                                : ""
                                            }`}
                                        id="stevilkaSpisaIzvrsitelja"
                                        name="stevilkaSpisaIzvrsitelja"
                                        value={stevilkaSpisaIzvrsitelja}
                                        onChange={(e) => {
                                            setStevilkaSpisaIzvrsitelja(e.target.value);

                                            if (manjkajocePolje === "stevilkaSpisaIzvrsitelja") {
                                                setManjkajocePolje("");
                                                setManjkajoceSporocilo("");
                                            }
                                        }}
                                    />
                                    {jeManjkajocePolje("stevilkaSpisaIzvrsitelja") &&
                                        manjkajoceSporocilo && (
                                            <span className="pod-fieldError">
                                                {manjkajoceSporocilo}
                                            </span>
                                        )}
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">Opr. št. sodišča</span>
                                    <input
                                        className={`pod-input pod-topInput ${jeManjkajocePolje("opravilnaStevilkaSodisca")
                                                ? "pod-input--error"
                                                : ""
                                            }`}
                                        id="opravilnaStevilkaSodisca"
                                        name="opravilnaStevilkaSodisca"
                                        value={opravilnaStevilkaSodisca}
                                        onChange={(e) => {
                                            obravnavaSpremembeOpravilneStevilke(e);

                                            if (manjkajocePolje === "opravilnaStevilkaSodisca") {
                                                setManjkajocePolje("");
                                                setManjkajoceSporocilo("");
                                            }
                                        }}
                                    />
                                    {jeManjkajocePolje("opravilnaStevilkaSodisca") &&
                                        manjkajoceSporocilo && (
                                            <span className="pod-fieldError">
                                                {manjkajoceSporocilo}
                                            </span>
                                        )}
                                </label>
                            </div>
                        </section>

                        <section className="pod-section">
                            <div className="pod-sectionHeader">
                                <h2 className="pod-sectionTitle">Iskanje dolžnika v AJPES</h2>
                            </div>

                            <div className="pod-inlineForm pod-inlineForm--ajpes">
                                <label className="pod-field pod-field--grow">
                                    <span className="pod-label">
                                        Matična ali davčna številka (24995975)
                                    </span>
                                    <input
                                        className={`pod-input ${jeManjkajocePolje("iskanjeDolznika")
                                                ? "pod-input--error"
                                                : ""
                                            }`}
                                        id="iskanjeDolznika"
                                        name="iskanjeDolznika"
                                        value={davcnaAliMaticna}
                                        onChange={(e) => {
                                            obravnavaSpremembeIskanja(e);

                                            if (manjkajocePolje === "iskanjeDolznika") {
                                                setManjkajocePolje("");
                                                setManjkajoceSporocilo("");
                                            }
                                        }}
                                        onKeyDown={obravnavaEnter}
                                        inputMode="numeric"
                                    />
                                    {jeManjkajocePolje("iskanjeDolznika") &&
                                        manjkajoceSporocilo && (
                                            <span className="pod-fieldError">
                                                {manjkajoceSporocilo}
                                            </span>
                                        )}
                                </label>

                                <button
                                    type="button"
                                    className="pod-btn"
                                    onClick={pridobiDolznika}
                                    disabled={nalaganje || nalaganjeIzBaze}
                                >
                                    {nalaganje || nalaganjeIzBaze
                                        ? "Iskanje…"
                                        : "Pridobi podatke"}
                                </button>
                            </div>

                            {napaka && (
                                <div className="pod-alert pod-alert--error">{napaka}</div>
                            )}
                        </section>

                        <section className="pod-grid">
                            <div className="pod-section">
                                <label className="pod-field">
                                    <span className="pod-label">Ime / firma</span>
                                    <input
                                        className="pod-input pod-input--readonly"
                                        id="imeDolznika"
                                        name="imeDolznika"
                                        value={imeDolznika}
                                        readOnly
                                        placeholder="- podatki še niso pridobljeni"
                                    />
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">Naslov</span>
                                    <input
                                        className="pod-input pod-input--readonly"
                                        id="naslovDolznika"
                                        name="naslovDolznika"
                                        value={naslovDolznika}
                                        readOnly
                                        placeholder="- podatki še niso pridobljeni"
                                    />
                                </label>

                                <div className="pod-field pod-field--inline">
                                    <span className="pod-label">
                                        Pošta / država / davčna št.
                                    </span>
                                    <div className="pod-inlineInputs">
                                        <input
                                            className="pod-input pod-input--readonly"
                                            id="postaDolznika"
                                            name="postaDolznika"
                                            value={postaDolznika}
                                            readOnly
                                            placeholder="Pošta"
                                        />
                                        <input
                                            className="pod-input pod-input--readonly"
                                            id="drzavaDolznika"
                                            name="drzavaDolznika"
                                            value={drzavaDolznika}
                                            readOnly
                                            placeholder="Država"
                                        />
                                        <input
                                            className="pod-input pod-input--readonly"
                                            id="davcnaStevilkaDolznika"
                                            name="davcnaStevilkaDolznika"
                                            value={davcnaStevilkaDolznika}
                                            readOnly
                                            placeholder="Davčna št."
                                        />
                                    </div>
                                </div>

                                <hr className="pod-separator" />

                                <div className="pod-sectionHeader">
                                    <h3 className="pod-sectionTitle">
                                        Predhodno zarubljene premičnine
                                    </h3>
                                </div>

                                {prejsnjiRubezi.map((vrstica, index) => (
                                    <div key={index} className="pod-prevCard">
                                        <div className="pod-prevGrid">
                                            <label className="pod-field">
                                                <span className="pod-label">Kateri rubež</span>
                                                <select
                                                    className="pod-input"
                                                    id={`prejsnjiRubez-${index}-stevilkaRubeza`}
                                                    name={`prejsnjiRubezi[${index}].stevilkaRubeza`}
                                                    value={vrstica.stevilkaRubeza}
                                                    onChange={(e) =>
                                                        obravnavaSpremembePrejsnjegaRubeza(
                                                            index,
                                                            "stevilkaRubeza",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">- izberi</option>
                                                    {[1, 2, 3, 4, 5].map((n) => (
                                                        <option key={n} value={n}>
                                                            {n}. rubež
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>

                                            <label className="pod-field">
                                                <span className="pod-label">
                                                    Predmet rubeža
                                                </span>
                                                <select
                                                    className="pod-input"
                                                    id={`prejsnjiRubez-${index}-predmetRubeza`}
                                                    name={`prejsnjiRubezi[${index}].predmetRubeza`}
                                                    value={vrstica.predmetRubeza}
                                                    onChange={(e) =>
                                                        obravnavaSpremembePrejsnjegaRubeza(
                                                            index,
                                                            "predmetRubeza",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">- izberi</option>
                                                    {MOZNOSTI_PREDMETA.map((opt) => (
                                                        <option key={opt} value={opt}>
                                                            {opt}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>

                                            <label className="pod-field">
                                                <span className="pod-label">
                                                    Sredstvo rubeža
                                                </span>
                                                <select
                                                    className="pod-input"
                                                    id={`prejsnjiRubez-${index}-sredstvoRubeza`}
                                                    name={`prejsnjiRubezi[${index}].sredstvoRubeza`}
                                                    value={vrstica.sredstvoRubeza}
                                                    onChange={(e) =>
                                                        obravnavaSpremembePrejsnjegaRubeza(
                                                            index,
                                                            "sredstvoRubeza",
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">- izberi</option>
                                                    {MOZNOSTI_SREDSTVA.map((opt) => (
                                                        <option key={opt} value={opt}>
                                                            {opt}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                        </div>

                                        {prejsnjiRubezi.length > 1 && (
                                            <button
                                                type="button"
                                                className="pod-btn pod-btn--ghost pod-prevRemoveBtn"
                                                onClick={() => odstraniPrejsnjiRubez(index)}
                                            >
                                                Odstrani vrstico
                                            </button>
                                        )}
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    className="pod-btn pod-btn--ghost"
                                    onClick={dodajPrejsnjiRubez}
                                >
                                    + Dodaj predhodni rubež
                                </button>

                                <div className="pod-trafficCard">
                                    <div className="pod-trafficHeader">
                                        <span className="pod-trafficTitle">
                                            Status rubežev
                                        </span>
                                    </div>

                                    <div className="pod-trafficLights">
                                        <div className="pod-trafficItem">
                                            <span className="pod-trafficDot pod-trafficDot--green" />
                                            <span className="pod-trafficLabel">
                                                Prvič zarubljeno
                                            </span>
                                            <span
                                                className="pod-trafficInfo"
                                                data-tooltip="Trudi se sam poplačevati."
                                                tabIndex={0}
                                            >
                                                i
                                            </span>
                                        </div>

                                        <div className="pod-trafficItem">
                                            <span className="pod-trafficDot pod-trafficDot--yellow" />
                                            <span className="pod-trafficLabel">
                                                Do 3x zarubljeno
                                            </span>
                                            <span
                                                className="pod-trafficInfo"
                                                data-tooltip="Trudi se sam poplačevati glede na pozive izvršitelja."
                                                tabIndex={0}
                                            >
                                                i
                                            </span>
                                        </div>

                                        <div className="pod-trafficItem">
                                            <span className="pod-trafficDot pod-trafficDot--red" />
                                            <span className="pod-trafficLabel">
                                                4x rubeži ali več
                                            </span>
                                            <span
                                                className="pod-trafficInfo"
                                                data-tooltip="Ne trudi se sam poplačevati niti po pozivu izvršitelja. Stvari se prodajajo na javni dražbi in dolguje več kot 5 upnikom."
                                                tabIndex={0}
                                            >
                                                i
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="pod-section">
                                <label className="pod-field">
                                    <span className="pod-label">GSM</span>
                                    <input
                                        className="pod-input"
                                        id="gsmDolznika"
                                        name="gsmDolznika"
                                        type="tel"
                                        inputMode="tel"
                                        pattern="[0-9+ ]*"
                                        value={gsmDolznika}
                                        onChange={(e) => {
                                            const formatirano = formatirajTelefonVnos(
                                                e.target.value
                                            );
                                            setGsmDolznika(formatirano);
                                        }}
                                    />
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">Kontakt</span>
                                    <input
                                        className="pod-input"
                                        id="telefonDolznika"
                                        name="telefonDolznika"
                                        type="tel"
                                        inputMode="tel"
                                        pattern="[0-9+ ]*"
                                        value={telefonDolznika}
                                        onChange={(e) => {
                                            const formatirano = formatirajTelefonVnos(
                                                e.target.value
                                            );
                                            setTelefonDolznika(formatirano);
                                        }}
                                    />
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">E-pošta</span>
                                    <input
                                        className={`pod-input ${emailNapaka ||
                                                jeManjkajocePolje("ePostaDolznika")
                                                ? "pod-input--error"
                                                : ""
                                            }`}
                                        id="ePostaDolznika"
                                        name="ePostaDolznika"
                                        type="email"
                                        value={ePostaDolznika}
                                        onChange={(e) => {
                                            setEPostaDolznika(e.target.value);

                                            if (emailNapaka) setEmailNapaka("");
                                            if (manjkajocePolje === "ePostaDolznika") {
                                                setManjkajocePolje("");
                                                setManjkajoceSporocilo("");
                                            }
                                        }}
                                    />
                                    {jeManjkajocePolje("ePostaDolznika") &&
                                        manjkajoceSporocilo && (
                                            <span className="pod-fieldError">
                                                {manjkajoceSporocilo}
                                            </span>
                                        )}
                                    {emailNapaka && (
                                        <span className="pod-fieldError">
                                            {emailNapaka}
                                        </span>
                                    )}
                                </label>

                                <hr className="pod-separator" />

                                <label className="pod-field">
                                    <span className="pod-label">Glavnica</span>
                                    <div className="pod-moneyWrap">
                                        <input
                                            className="pod-input pod-moneyInput"
                                            id="glavnica"
                                            name="glavnica"
                                            type="text"
                                            inputMode="decimal"
                                            placeholder="0,00"
                                            value={glavnica}
                                            onChange={(e) =>
                                                setGlavnica(ocistiDenarniVnos(e.target.value))
                                            }
                                            onBlur={(e) =>
                                                setGlavnica(formatMoneySl(e.target.value))
                                            }
                                        />
                                        <span className="pod-moneySuffix">€</span>
                                    </div>
                                </label>

                                <div className="pod-field pod-field--inline">
                                    <span className="pod-label">Obresti (od – do)</span>
                                    <div className="pod-inlineInputs">
                                        <input
                                            className="pod-input"
                                            id="obrestiOd"
                                            name="obrestiOd"
                                            type="date"
                                            value={obrestiOd}
                                            onChange={(e) => setObrestiOd(e.target.value)}
                                        />
                                        <span className="pod-inlineSeparator">–</span>
                                        <input
                                            className="pod-input"
                                            id="obrestiDo"
                                            name="obrestiDo"
                                            type="date"
                                            value={obrestiDo}
                                            onChange={(e) => setObrestiDo(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <label className="pod-field">
                                    <span className="pod-label">Stroški</span>
                                    <div className="pod-moneyWrap">
                                        <input
                                            className="pod-input pod-moneyInput"
                                            id="stroski"
                                            name="stroski"
                                            type="text"
                                            inputMode="decimal"
                                            placeholder="0,00"
                                            value={stroski}
                                            onChange={(e) =>
                                                setStroski(ocistiDenarniVnos(e.target.value))
                                            }
                                            onBlur={(e) =>
                                                setStroski(formatMoneySl(e.target.value))
                                            }
                                        />
                                        <span className="pod-moneySuffix">€</span>
                                    </div>
                                </label>

                                <label className="pod-field">
                                    <span className="pod-label">Skupaj dolg na dan</span>
                                    <div className="pod-moneyWrap">
                                        <input
                                            className="pod-input pod-moneyInput"
                                            id="skupajDolgNaDan"
                                            name="skupajDolgNaDan"
                                            type="text"
                                            inputMode="decimal"
                                            placeholder="0,00"
                                            value={skupajDolgNaDan}
                                            onChange={(e) =>
                                                setSkupajDolgNaDan(
                                                    ocistiDenarniVnos(e.target.value)
                                                )
                                            }
                                            onBlur={(e) =>
                                                setSkupajDolgNaDan(formatMoneySl(e.target.value))
                                            }
                                        />
                                        <span className="pod-moneySuffix">€</span>
                                    </div>
                                </label>

                                <div className="pod-saveRow">
                                    {sporociloShranjevanja && (
                                        <span className="pod-saveMessage">
                                            {sporociloShranjevanja}
                                        </span>
                                    )}

                                    <button
                                        type="button"
                                        className="pod-btn pod-saveButton"
                                        onClick={shraniStran}
                                        disabled={shranjevanje}
                                    >
                                        {shranjevanje
                                            ? "Shranjujem…"
                                            : urejanjeObstojecega
                                                ? "Posodobi"
                                                : "Shrani"}
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            </main>
        </div>
    );
}